import { ObjectSettingsDtoRead } from '@/rtkApi/mddApiSliceGeneratedV2'

export type ObjectSettingGroup = {
	objects: ObjectSettingsDtoRead[]
	structureType: string
}

export const groupObjectSettings = (items: ObjectSettingsDtoRead[]): ObjectSettingGroup[] => {
	const groups = new Map<string, ObjectSettingsDtoRead[]>()

	items.forEach((item) => {
		if (item.id == null) return
		const structureType = item.structureType ?? ''
		const current = groups.get(structureType) ?? []
		current.push(item)
		groups.set(structureType, current)
	})

	return [...groups.entries()]
		.sort(([left], [right]) => left.localeCompare(right, undefined, { sensitivity: 'base' }))
		.map(([structureType, objects]) => ({
			objects: [...objects].sort((left, right) =>
				left.code.localeCompare(right.code, undefined, { sensitivity: 'base' }),
			),
			structureType,
		}))
}

export const structureObjectPairs = (
	items: ObjectSettingsDtoRead[],
	selectedIds: number[],
) => {
	const selected = new Set(selectedIds)
	const pairs: Record<string, string[]> = {}

	items.forEach((item) => {
		if (item.id == null || !item.structureType || !selected.has(item.id)) return
		pairs[item.structureType] = [...(pairs[item.structureType] ?? []), item.code]
	})

	return pairs
}
